import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { IMAGES } from '../../data/images';
import { useLanguage } from '../../i18n/LanguageContext';
type CtaBannerProps = {
  title?: string;
  description?: string;
};
export function CtaBanner({
  title,
  description
}: CtaBannerProps) {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full overflow-hidden bg-navy-950" data-id="element-290" data-mp="2p4cujn9fk5ki">
      <img src={IMAGES.cta} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-30" data-id="element-291" data-mp="2u2xmkzej3ixv" />
      <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/85 to-navy-950/70" aria-hidden="true" data-id="element-292" data-mp="2z0fz0zrr8gam" />
      <div className="relative mx-auto max-w-container px-6 py-24 text-center lg:py-28" data-id="element-293" data-mp="26dd5km1xqvr8">
        <Reveal data-id="element-294" data-mp="26bioxjxp5psy">
          <p className="eyebrow text-gold" data-id="element-295" data-mp="2bc6ee16a1yl2">{t.cta.eyebrow}</p>
          <h2 className="mx-auto mt-6 max-w-3xl font-display text-3xl font-medium leading-[1.15] text-white sm:text-4xl lg:text-5xl" data-id="element-296" data-mp="2bad8io3hnie4">
            {title ?? t.cta.title}
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-navy-100/70" data-id="element-297" data-mp="3mcg9hh34ky32">
            {description ?? t.cta.description}
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-298" data-mp="3djuw6gi9jjlm">
            <Link to="/contact" className="group inline-flex items-center gap-2 rounded-full bg-gold px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.16em] text-navy transition-all duration-300 hover:bg-gold-light hover:shadow-lift" data-id="element-299" data-mp="38k8i64um1zbr">
              {t.cta.ctaPrimary}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-300" data-mp="2ulikoo3vpxmv" />
            </Link>
            <Link to="/contact" className="inline-flex items-center gap-2 rounded-full border border-white/25 px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.16em] text-white transition-all duration-300 hover:border-gold hover:text-gold" data-id="element-301" data-mp="st43xsd2mz81">
              {t.cta.ctaSecondary}
            </Link>
          </div>
        </Reveal>
      </div>
    </section>;
}